import { useState } from 'react';
import { useInterval } from 'usehooks-ts';

export default function usePeriodicValue<T>(valueFn: () => T, interval: number | null) {
  const [value, setValue] = useState<T>(valueFn);

  useInterval(() => {
    setValue(valueFn());
  }, interval);

  return value;
}
